<div class="dropdown">
  <button
    class="btn app-btn-soft fw-bold px-2 px-sm-3 d-inline-flex align-items-center justify-content-center gap-2"
    type="button"
    [id]="dropdownId"
    data-bs-toggle="dropdown"
    [attr.aria-label]="label"
    aria-expanded="false">
    <fa-icon [icon]="faSort"></fa-icon>
    <span class="d-none d-sm-inline">{{ label }}</span>
  </button>

  <ul class="dropdown-menu app-dropdown-menu" [attr.aria-labelledby]="dropdownId">
    @for (option of options; track option.label) {
      <li>
        <button
          class="dropdown-item"
          [class.is-active]="option === selected"
          type="button"
          (click)="selectedChange.emit(option)">
          {{ option.label }}
        </button>
      </li>
    }
  </ul>
</div>
